import React from 'react';
import { Link } from 'react-router-dom';
import styles from './SiteFooter.module.css';
import { trackEvent } from '../../utils/analytics';

const CONTACT_EMAIL = 'info@velox-network.com';
const SHOP_URL = 'https://veloxco.com';

const SiteFooter = () => {
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className="vxm-container">
        <div className={styles.columns}>
          <div className={styles.brandColumn}>
            <img
              src="https://velox-network-media.s3.eu-west-2.amazonaws.com/Picture+2.png"
              alt="Velox Network"
              className={styles.logo}
              width="120"
              height="30"
            />
            <p className={styles.tagline}>
              Make every introduction count: capture, remember, find and
              follow up.
            </p>
          </div>

          <nav className={styles.column} aria-labelledby="footer-product">
            <h2 id="footer-product" className={styles.columnTitle}>Product</h2>
            <Link to="/product" className={styles.footerLink}>Platform</Link>
            <Link to="/how-it-works" className={styles.footerLink}>How it works</Link>
            <Link to="/help" className={styles.footerLink}>Help</Link>
            <Link to="/security-privacy" className={styles.footerLink}>Security &amp; Privacy</Link>
            <a
              href={SHOP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.footerLink}
              onClick={() => trackEvent('Marketing CTA', 'shop_click', 'footer')}
            >
              Order a card
            </a>
          </nav>

          <nav className={styles.column} aria-labelledby="footer-solutions">
            <h2 id="footer-solutions" className={styles.columnTitle}>Solutions</h2>
            <Link to="/professionals" className={styles.footerLink}>Professionals</Link>
            <Link to="/enterprise" className={styles.footerLink}>Teams</Link>
            <Link to="/why-velox" className={styles.footerLink}>About</Link>
            <Link to="/register" className={styles.footerLink}>Create account</Link>
            <Link to="/login" className={styles.footerLink}>Sign in</Link>
          </nav>

          <nav className={styles.column} aria-labelledby="footer-company">
            <h2 id="footer-company" className={styles.columnTitle}>Company</h2>
            <a href={`mailto:${CONTACT_EMAIL}`} className={styles.footerLink}>
              Contact us
            </a>
            <Link to="/policy/privacy" className={styles.footerLink}>Privacy Policy</Link>
            <Link to="/policy/terms" className={styles.footerLink}>Terms of Service</Link>
            <Link to="/policy/cookies" className={styles.footerLink}>Cookie Policy</Link>
            <Link to="/policy/accessibility" className={styles.footerLink}>Accessibility</Link>
          </nav>
        </div>

        <div className={styles.legal}>
          <address className={styles.address}>
            <strong className={styles.legalName}>Velox Technologies Ltd</strong>
            Registered in England and Wales, company number 17253697.<br />
            Registered office: 128 City Road, London, United Kingdom, EC1V 2NX.<br />
            <a href={`mailto:${CONTACT_EMAIL}`} className="vxm-link">{CONTACT_EMAIL}</a>
          </address>
          <p className={styles.copyright}>
            &copy; {year} Velox Technologies Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
